// src/components/Navbar.js
import React from 'react';
import { AppBar, Toolbar, Typography, Button, Box, Chip, IconButton, Tooltip } from '@mui/material';
import { Link } from 'react-router-dom';
import LanguageSwitcher from "./LanguageSwitcher";
import LightModeRoundedIcon from '@mui/icons-material/LightModeRounded';
import DarkModeRoundedIcon from '@mui/icons-material/DarkModeRounded';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';

const Navbar = ({ isAuthenticated, handleLogout, colorMode, toggleColorMode }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';

  return (
    <AppBar
      position="sticky"
      color="transparent"
      elevation={0}
      sx={{
        backdropFilter: 'blur(18px)',
        background: isDark ? 'rgba(7, 17, 31, 0.78)' : 'rgba(243, 248, 253, 0.84)',
        borderBottom: '1px solid',
        borderColor: 'divider',
      }}>
      <Toolbar
        sx={{
          maxWidth: 1440,
          width: '100%',
          mx: 'auto',
          px: {xs: 2, md: 3},
          py: 0.75,
          gap: 1.25,
          flexWrap: { xs: 'wrap', md: 'nowrap' },
        }}
      >
        <Box sx={{display: 'flex', alignItems: 'center', gap: 1.5, flexGrow: 1, minWidth: 0}}>
          <Chip
            label="NYMERA"
            sx={{
              backgroundColor: isDark ? 'rgba(88, 196, 221, 0.12)' : 'rgba(17, 127, 164, 0.12)',
              color: 'primary.main',
              border: '1px solid',
              borderColor: isDark ? 'rgba(88, 196, 221, 0.25)' : 'rgba(17, 127, 164, 0.22)',
              fontWeight: 700,
            }}
          />
          <Typography
            variant="body2"
            sx={{color: 'text.secondary', display: {xs: 'none', lg: 'block'}, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'}}
          >
            {t('nav.tagline')}
          </Typography>
        </Box>
        <LanguageSwitcher />
        <Tooltip title={colorMode === 'dark' ? t('common.switchToLight') : t('common.switchToDark')}>
          <IconButton
            onClick={toggleColorMode}
            sx={{
              color: 'text.primary',
              border: '1px solid',
              borderColor: 'divider',
              backgroundColor: 'background.paper',
            }}
          >
            {colorMode === 'dark' ? <LightModeRoundedIcon /> : <DarkModeRoundedIcon />}
          </IconButton>
        </Tooltip>
        {isAuthenticated && (
          <Button color="inherit" component={Link} to="/dashboard" sx={{ color: 'text.primary' }}>
            {t('nav.overview')}
          </Button>
        )}
        {isAuthenticated && (
          <Button color="inherit" component={Link} to="/predictions" sx={{ color: 'text.primary' }}>
            {t('nav.decisions')}
          </Button>
        )}
        {!isAuthenticated ? (
          <>
            <Button color="inherit" component={Link} to="/login" sx={{ color: 'text.primary' }}>
              {t('nav.login')}
            </Button>
            <Button
              variant="contained"
              color="primary"
              component={Link}
              to="/register"
              sx={{ px: 2.25 }}
            >
              {t('nav.createAccount')}
            </Button>
          </>
        ) : (
          <Button color="inherit" onClick={handleLogout} sx={{ color: 'text.primary' }}>
            {t('nav.logout')}
          </Button>
        )}
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
